import {MonoBehaviour} from "../Utils/Unity/MonoBehaviour";

export class JSONGameData extends MonoBehaviour {

    constructor(json) {
        super();
        this.Awake();
        if (json) {
            this.Init(json);
        }
    }

    Awake() {
        super.Awake();
    }

    Init(json) {
        this.fromJSON(json);
    }

    fromJSON(json) {
        json = json || {};
        for (let [prop, value] of Object.entries(json)) {
            this[prop] = value;
        }
    }

    toJSON() {
        return this;
    }
}
